














import Vue from 'vue';
import Component from 'vue-class-component';
import AppFooter from '@/components/AppFooter.vue';
import CookieLaw from 'vue-cookie-law';

@Component({
  name: 'App',
  components: {AppFooter, CookieLaw},
})
export default class App extends Vue {

}
